import { Pipe } from '@angular/core';
import { isUndefined, isObject, extractDeepPropertyByMapKey } from '../helpers/helpers';
var UniquePipe = (function () {
    function UniquePipe() {
    }
    UniquePipe.prototype.transform = function (input, propertyName) {
        var uniques = [];
        return Array.isArray(input) ?
            isUndefined(propertyName) ?
                input.filter(function (e, i) { return input.indexOf(e) === i; }) :
                input.filter(function (e, i) {
                    var value = extractDeepPropertyByMapKey(e, propertyName);
                    value = isObject(value) ? JSON.stringify(value) : value;
                    if (isUndefined(value) || uniques[value]) {
                        return false;
                    }
                    uniques[value] = true;
                    return true;
                }) : input;
    };
    return UniquePipe;
}());
export { UniquePipe };
UniquePipe.decorators = [
    { type: Pipe, args: [{ name: 'unique' },] },
];
/** @nocollapse */
UniquePipe.ctorParameters = function () { return []; };
//# sourceMappingURL=unique.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/array/unique.js
// module id = 215
// module chunks = 4